import { MessageOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Descriptions,
  Form,
  Input,
  message,
  Row,
  Table,
  Tooltip,
  Typography
} from 'antd';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useHistory } from 'react-router-dom';
import { Subtitle } from '../../../components';
import InputMask from '../../../components/input-mask';
import ResponsiveContainer from '../../../components/ResponsiveContainer';
import EmpresaContext from '../../../context/empresa-context';
import { useSiniestroContext } from '../../../context/siniestro-context';
import {
  errorHandler,
  formatCelular,
  parseCelular,
  prefijos3Digitos,
  validarCaracterEspecial
} from '../../../utils';
import { instanceRef } from '../../../utils/axios';
import ConfirmarDatos from '../ConfirmarDatos';

const { Title } = Typography;

const Confirmar = ({ datosIngresados, setStep }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const { setLoading, datosSiniestro } = useSiniestroContext();
  const [loadingSms, setLoadingSms] = useState(false);
  const history = useHistory();
  const { empresa } = useContext(EmpresaContext);
  const contacto =
    datosSiniestro.poliza?.solicitud?.cotizacion?.persona?.via_contacto;
  const canal =
    empresa.tiene_whatsapp && contacto === 'whatsapp' ? 'Whatsapp' : 'SMS';

  const sendSms = async () => {
    try {
      const reCaptchaToken = await executeRecaptcha('sms/siniestro');
      const data = {
        reCaptchaToken,
        token: datosSiniestro.token,
        idEmpresa:
          datosSiniestro.poliza.solicitud.cotizacion.aseguradoraEmpresa
            .id_empresa
      };
      message.info(
        `${datosSiniestro.poliza.solicitud.cotizacion.persona.celular} recibirá un mensaje de texto para firmar el documento`
      );
      await instanceRef.instance.post(`sms/siniestro`, data);
      history.push('/');
    } catch (error) {
      // error
    }
  };

  const onFinish = async () => {
    const datos = {
      ...datosIngresados,
      tiene_terceros: datosIngresados.tiene_terceros,
      tiene_lesionados: datosIngresados.tiene_lesionados,
      tiene_testigos: datosIngresados.tiene_testigos,
      intervino_autoridad: !!datosIngresados.autoridad,
      id: datosSiniestro.id
    };
    if (datosSiniestro.poliza.producto.codigo === 1) {
      datos.terceros = datosIngresados.tiene_terceros
        ? datosIngresados.terceros.map((obj) => ({
            ...obj,
            celular: obj.celular
              ? `${datosIngresados.prefix}${formatCelular(obj.celular)}`
              : '',
            tipo: 'TERCERO',
            datos_adicionales: {
              datos: obj.datos_adicionales,
              chapa: obj.chapa
            }
          }))
        : [];
      datos.lesionados = datosIngresados.tiene_lesionados
        ? datosIngresados.lesionados.map((obj) => ({
            ...obj,
            celular: obj.celular
              ? `${datosIngresados.prefix}${formatCelular(obj.celular)}`
              : '',
            tipo: 'LESIONADO'
          }))
        : [];
      datos.testigos = datosIngresados.tiene_testigos
        ? datosIngresados.testigos.map((obj) => ({
            ...obj,
            celular: obj.celular
              ? `${datosIngresados.prefix}${formatCelular(obj.celular)}`
              : '',
            tipo: 'TESTIGO'
          }))
        : [];
    }

    datos.detalles = {
      autoridad: datosIngresados.checkAutoridad
        ? datosIngresados.autoridad
        : null,
      nombre_conductor: datosIngresados.nombre_conductor,
      danios_vehiculo: datosIngresados.danios_vehiculo,
      lesiones: datosIngresados.lesiones,
      danios_inmueble: datosIngresados.danios_inmueble
    };
    if (
      datosSiniestro.poliza.producto.codigo === 1 ||
      datosSiniestro.poliza.producto.codigo === 7 ||
      datosSiniestro.poliza.producto.codigo === 2 ||
      datosSiniestro.poliza.producto.codigo === 3
    )
      datos.lugar = `${datosIngresados.departamentoLabel}, ${datosIngresados.distritoLabel}, ${datosIngresados.domicilio}`;
    datos.fecha_siniestro = moment(
      `${datos.fecha_siniestro.format(
        'DD/MM/YYYY'
      )} ${datos.hora_siniestro.format('HH:mm:ss')}`,
      'DD/MM/YYYY HH:mm:ss'
    ).format();
    updateSiniestro(datos);
  };

  const goBack = () => {
    if (datosSiniestro.poliza.producto.codigo === 1) setStep(1);
    else setStep(0);
  };

  const updateSiniestro = (datos) => {
    setLoading(true);
    instanceRef.instance
      .put(`/siniestro/${datosSiniestro.token}`, datos)
      .then(() => {
        history.push(`/firmar-denuncia/${datosSiniestro.token}`);
      })
      .catch((err) => {
        errorHandler(err, err.message);
      });
  };

  const ContactForm = () => {
    return (
      <Card style={{ padding: 0, width: '100%' }}>
        <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Nombre y apellido"
              name="nombres"
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: 'Nombre y apellido es un campo requerido'
                }
              ]}
              onKeyPress={(e) => {
                const pressedKey = String.fromCharCode(
                  !e.charCode ? e.which : e.charCode
                );
                validarCaracterEspecial(e, pressedKey);
              }}
              onPaste={(e) => {
                const pastedText = e.clipboardData.getData('text');
                validarCaracterEspecial(e, pastedText);
              }}
            >
              <Input placeholder="Nombre del Cliente" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Nro. de contacto"
              name="celular"
              rules={[
                {
                  required: true
                },
                {
                  pattern: `^\\((${prefijos3Digitos.join(
                    '|'
                  )})\\) [0-9]{3}-[0-9]{3}$`,
                  message: 'Número no válido'
                }
              ]}
            >
              <InputMask
                mask="(999) 999-999"
                placeholder="(___) ___-___"
                addonBefore="+595"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Correo"
              name="correo"
              rules={[
                {
                  required: true
                },
                {
                  type: 'email',
                  message: 'El correo no es válido'
                }
              ]}
            >
              <Input placeholder="Ingrese un valor" />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    );
  };

  const columnsTerceros = [
    {
      title: 'Nombres',
      dataIndex: 'nombres',
      key: 'nombres'
    },
    {
      title: 'Nro. Contacto',
      dataIndex: 'celular',
      key: 'celular',
      render: (_, record) => {
        if (record.celular) {
          return `+595${formatCelular(record.celular)}`;
        }
        return '';
      }
    },
    {
      title: 'Datos Adicionales',
      dataIndex: 'datos_adicionales',
      key: 'datos_adicionales',
      render: (_, record) => {
        if (record.datos_adicionales) {
          return record.datos_adicionales;
        }
        return '';
      }
    },
    {
      title: 'Chapa',
      dataIndex: 'chapa',
      key: 'chapa',
      render: (_, record) => {
        if (record.chapa) {
          return record.chapa;
        }
        return '';
      }
    }
  ];

  const columns = [
    {
      title: 'Nombres',
      dataIndex: 'nombres',
      key: 'nombres'
    },
    {
      title: 'Nro. Contacto',
      dataIndex: 'celular',
      key: 'celular',
      render: (_, record) => {
        if (record.celular) {
          return `+595${formatCelular(record.celular)}`;
        }
        return '';
      }
    }
  ];

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  return (
    <ResponsiveContainer>
      <Subtitle>¡Confirmá los datos del Siniestro!</Subtitle>
      <Descriptions
        title="Datos del Accidente"
        style={{ textAlign: 'left', paddingBottom: 40 }}
        bordered
        size="small"
        column={{ md: 2, sm: 1, xs: 1 }}
      >
        <Descriptions.Item
          label="Fecha Ocurrencia"
          labelStyle={{ width: '5em' }}
        >
          {datosIngresados.fecha_siniestro.format('DD/MM/YYYY')}
        </Descriptions.Item>
        <Descriptions.Item label="Hora Ocurrencia">
          {datosIngresados.hora_siniestro.format('HH:mm')}
        </Descriptions.Item>
        <Descriptions.Item label="Circunstancia de Ocurrencia">
          {datosIngresados.circunstancia_ocurrencia}
        </Descriptions.Item>
        {(datosSiniestro?.poliza?.producto.codigo === 4 ||
          datosSiniestro?.poliza?.producto.codigo === 5 ||
          datosSiniestro?.poliza?.producto.codigo === 6) && (
          <Descriptions.Item label="Detalle de Daños">
            {datosIngresados.danios_inmueble}
          </Descriptions.Item>
        )}
        {(datosSiniestro?.poliza?.producto.codigo === 2 ||
          datosSiniestro?.poliza?.producto.codigo === 3) && (
          <>
            <Descriptions.Item label="Descripción de Lesiones">
              {datosIngresados.lesiones}
            </Descriptions.Item>
            <Descriptions.Item label="Departamento">
              {datosIngresados.departamentoLabel}
            </Descriptions.Item>
            <Descriptions.Item label="Distrito">
              {datosIngresados.distritoLabel}
            </Descriptions.Item>
            <Descriptions.Item label="Lugar del siniestro">
              {datosIngresados.domicilio}
            </Descriptions.Item>
          </>
        )}
        {(datosSiniestro?.poliza?.producto.codigo === 1 ||
          datosSiniestro?.poliza?.producto.codigo === 7) && (
          <>
            <Descriptions.Item label="Nombre del Conductor">
              {datosIngresados.nombre_conductor}
            </Descriptions.Item>
            <Descriptions.Item label="Velocidad de Circulación">
              {datosIngresados.velocidad_circulacion}km/h
            </Descriptions.Item>
            <Descriptions.Item label="Daños del Vehículo">
              {datosIngresados.danios_vehiculo}
            </Descriptions.Item>
            <Descriptions.Item label="Departamento">
              {datosIngresados.departamentoLabel}
            </Descriptions.Item>
            <Descriptions.Item label="Distrito">
              {datosIngresados.distritoLabel}
            </Descriptions.Item>
            <Descriptions.Item label="Lugar del siniestro">
              {datosIngresados.domicilio}
            </Descriptions.Item>
          </>
        )}
      </Descriptions>

      {(datosSiniestro?.poliza?.producto.codigo === 1 ||
        datosSiniestro?.poliza?.producto.codigo === 7) && (
        <>
          <Title level={5} style={{ textAlign: 'left' }}>
            Datos de Personas Involucradas
          </Title>
          <Title level={5} style={{ textAlign: 'left' }}>
            Terceros
          </Title>
          {!datosIngresados.tiene_terceros ||
          datosIngresados.terceros.length < 1 ? (
            <span style={{ justifyContent: 'start', display: 'flex' }}>
              No hubo terceros
            </span>
          ) : (
            <Table
              fixed
              scroll={false}
              style={{ width: '100%' }}
              bordered
              dataSource={datosIngresados.terceros}
              columns={columnsTerceros}
              pagination={false}
              rowKey={(record) => record.id}
              size="small"
            />
          )}
          <br />
          <Title level={5} style={{ textAlign: 'left' }}>
            Lesionados
          </Title>
          {!datosIngresados.tiene_lesionados ||
          datosIngresados.lesionados.length < 1 ? (
            <span style={{ justifyContent: 'start', display: 'flex' }}>
              No hubo lesionados
            </span>
          ) : (
            <Table
              fixed
              scroll={false}
              style={{ width: '100%' }}
              bordered
              dataSource={datosIngresados.lesionados}
              columns={columns}
              pagination={false}
              rowKey={(record) => record.id}
              size="small"
            />
          )}
          <br />
          <Title level={5} style={{ textAlign: 'left' }}>
            Testigos
          </Title>
          {!datosIngresados.tiene_testigos ||
          datosIngresados.testigos.length < 1 ? (
            <span style={{ justifyContent: 'start', display: 'flex' }}>
              No hubo testigos
            </span>
          ) : (
            <Table
              fixed
              scroll={false}
              style={{ width: '100%' }}
              bordered
              dataSource={datosIngresados.testigos}
              columns={columns}
              pagination={false}
              rowKey={(record) => record.id}
              size="small"
            />
          )}

          <br />
          <Descriptions
            title="Datos Autoridad"
            style={{ textAlign: 'left', paddingBottom: 40 }}
            bordered
            size="small"
            column={{ md: 2, sm: 1, xs: 1 }}
          >
            <Descriptions.Item label="Autoridad" labelStyle={{ width: '5em' }}>
              {datosIngresados.autoridad}
              {!datosIngresados.autoridad && (
                <span>No intervino autoridad</span>
              )}
            </Descriptions.Item>
          </Descriptions>
        </>
      )}

      <ConfirmarDatos
        title=""
        contacto={false}
        datosIngresados={datosIngresados}
      />
      <Form
        onFinish={onFinish}
        layout="vertical"
        name="confirm"
        initialValues={{
          nombres: datosSiniestro.detalles.declarante
            ? datosSiniestro.detalles.declarante.nombres
            : '',
          celular: datosSiniestro.detalles.declarante
            ? parseCelular(datosSiniestro.detalles.declarante.celular)
            : '',
          correo: datosSiniestro.detalles.declarante
            ? datosSiniestro.detalles.declarante.correo
            : ''
        }}
      >
        <Descriptions
          title="Datos del Declarante"
          style={{ textAlign: 'left', marginTop: 30 }}
        >
          <Descriptions.Item label="">
            <ContactForm />
          </Descriptions.Item>
        </Descriptions>
      </Form>

      <Button style={{ margin: 10 }} onClick={goBack}>
        Anterior
      </Button>
      <Button type="primary" onClick={onFinish}>
        Firmar documento
      </Button>

      {(empresa.tiene_sms || empresa.tiene_whatsapp) && (
        <Tooltip title={`Enviar por ${canal} el enlace para firmar`}>
          <Button
            type="dashed"
            style={{ margin: 10 }}
            onClick={() => {
              setLoadingSms(true);
              sendSms();
            }}
            icon={<MessageOutlined />}
            loading={loadingSms}
          >
            Enviar {canal} para firmar
          </Button>
        </Tooltip>
      )}
    </ResponsiveContainer>
  );
};

export default Confirmar;
